import styled from 'styled-components';

const PromotionItemWrapper = styled.div`
  .promotion-name {
    margin-top: 10px;
    color: #0d092b;
    font-family: 'Lava Pro', serif;
    font-style: normal;
    font-weight: 700;
    font-size: 21px;
    line-height: 1;
    margin-bottom: 0;
  }

  .promotion-description {
    margin-top: 5px;
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    width: 300px;
    color: #090623;
  }

  .promotion-image {
    min-height: 140px;
    max-height: 140px;
    //max-width: 300px;

    border-radius: 24px;
    text-align: center;
    display: flex;
    justify-content: center;
    overflow: hidden;
    align-items: center;
  }

  .promotion-image img {
    max-width: 360px;
    height: 100%;
  }
`;

export default PromotionItemWrapper;
